import { getLogoColors } from '@lib/color';
import poweredByArovy from 'images/poweredByArovy.png';

import { DataSecurityAppLogos, DataSecurityAppName } from '@ui/applications';

export const getAppColor = async(appName: DataSecurityAppName, callback: (color: string) => void) => {
	const logoUrl = DataSecurityAppLogos[ appName ];

	if (logoUrl) {
		const [ topColor ] = logoUrl ? await getLogoColors(logoUrl) : [ { hex: '' } ];
		callback(topColor.hex);
	}
};

export function downloadFile(blob: Blob): void {
	if (blob) {
		const blobUrl = URL.createObjectURL(blob);
		const tempLink = document.createElement('a');

		tempLink.style.display = 'none';
		tempLink.href = blobUrl;
		tempLink.setAttribute('download', 'sonar-system-overview-graph.png');
		document.body.appendChild(tempLink);
		tempLink.click();
		document.body.removeChild(tempLink);

		setTimeout(() => {
			// For Firefox it is necessary to delay revoking the ObjectURL
			URL.revokeObjectURL(blobUrl);
		}, 100);
	}
}

export function addWatermark(fileUrl: string): Promise<Blob> {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.src = fileUrl;

		img.onload = () => {
			const canvas = document.createElement('canvas');

			const ctx = canvas.getContext('2d');
			if (!ctx) {
				reject(new Error('Failed to get canvas context'));

				return;
			}

			canvas.width = img.width;
			canvas.height = img.height;

			ctx.drawImage(img, 0, 0, img.width, img.height);

			const watermark = new Image();
			watermark.src = poweredByArovy;

			watermark.onload = () => {
				const watermarkPadding = 20;
				const watermarkWidth = 125;
				const watermarkHeight = (watermark.height / watermark.width) * watermarkWidth;
				const watermarkX = canvas.width - watermarkWidth - (2 * watermarkPadding);
				const watermarkY = canvas.height - watermarkHeight - (2 * watermarkPadding);

				ctx.drawImage(watermark, watermarkX, watermarkY, watermarkWidth, watermarkHeight);

				canvas.toBlob((blob) => {
					if (blob) {
						resolve(blob);
					} else {
						reject(new Error('Failed to create blob from canvas'));
					}
				});
			};
		};
	});
}
